import { render, staticRenderFns } from "./FinishConsume.vue?vue&type=template&id=10dc1691&scoped=true&"
import script from "./FinishConsume.vue?vue&type=script&lang=js&"
export * from "./FinishConsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc1691",
  null
  
)

export default component.exports